<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.ImportNfePage',
      breadcrumbItems: [
        { title: this.$t('Views.FinancialPage.title') },
        { name: 'ImportNfe', title: this.$t('Views.ImportNfePage.title') }
      ]
    }
  }
}
</script>
